import { FontFamily } from '@psl/components/styles/Colors';
import { StackNavigationOptions } from '@react-navigation/stack';
import { BackIcon } from '../../components/BackIcon';

export const screenOptionsForDarkMode = (
  overrides?: StackNavigationOptions,
): StackNavigationOptions => {
  return {
    headerStyle: {
      backgroundColor: '#000',
    },
    headerTitleStyle: {
      color: '#fff',
    },
    headerBackImage: () => <BackIcon fill="#fff" />,
    headerShadowVisible: false,
    cardStyle: {
      backgroundColor: '#000',
    },
    ...overrides,
  };
};

export const screenOptionsForLightMode = (
  overrides?: StackNavigationOptions,
): StackNavigationOptions => {
  return {
    headerBackTitle: ' ',
    headerTitleAlign: 'center',
    headerBackImage: () => <BackIcon fill={'#000'} />,
    headerTitleStyle: FontFamily.semiBold({
      color: undefined,
    }),
    headerShadowVisible: true,
    headerStyle: {
      elevation: 0,
      borderBottomWidth: 0,
      borderBottomColor: undefined,
      backgroundColor: undefined,
    },
    cardStyle: {
      backgroundColor: '#ffffff',
    },
    ...overrides,
  };
};
